import { CustomSchoolStatus, CustomSchoolStatusLabels, customSchoolStatusSchema } from '@airreading/common/data';

export const getCustomStatusLabel = (status: CustomSchoolStatus | null | undefined): string =>
  status ? CustomSchoolStatusLabels[status] : 'Unknown';

export const getCustomSchoolStatusOptions = () =>
  customSchoolStatusSchema.options.map((status) => ({
    label: getCustomStatusLabel(status),
    value: status,
  }));
